module.exports = __webpack_public_path__ + "img/picto-online.a0e09bfc.svg";